import type { ProfileProgress as ProfileProgressType } from '@/types';

interface ProfileProgressProps {
  progress: ProfileProgressType;
}

export function ProfileProgress({ progress }: ProfileProgressProps) {
  const { steps } = progress;
  const completedCount = steps.filter(s => s.status === 'complete').length;
  const totalCount = steps.length;
  const allDone = completedCount === totalCount;

  // Find the current step being worked on
  const currentStep = steps.find(s => s.status === 'in_progress');
  const lastCompleted = [...steps].reverse().find(s => s.status === 'complete');

  // Determine display label
  let label: string;
  let icon: string;

  if (allDone) {
    label = `Account profile ready — ${totalCount}/${totalCount} complete`;
    icon = '\u2713';
  } else if (currentStep) {
    label = currentStep.label + '...';
    icon = '\u23F3';
  } else if (lastCompleted) {
    label = lastCompleted.detail ?? `${lastCompleted.label} done`;
    icon = '\u23F3';
  } else {
    label = 'Scanning account...';
    icon = '\u23F3';
  }

  const progressPercent = (completedCount / totalCount) * 100;

  return (
    <div className="flex items-end gap-2 py-1.5">
      <video
        src="/zac-avatar.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="h-7 w-7 shrink-0 rounded-lg object-cover"
        aria-label="ZAC"
      />
      <div className="max-w-[85%] rounded-tl-2xl rounded-tr-2xl rounded-br-2xl rounded-bl-sm bg-white/[0.04] px-4 py-3">
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-1.5">
          <span>{icon}</span>
          <span>{label}</span>
        </div>
        <div className="h-1 w-48 rounded-full bg-muted overflow-hidden">
          <div
            className="h-full rounded-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
}
